import type { PayloadAction, WithSlice } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { rootReducer } from '~shared/store';

type State = {
  sessionId?: string;
  // Query params the app was entered with (utm_*, campaign ids, custom refs, …),
  // kept so they can be attached to the purchase event for channel attribution.
  attribution?: Record<string, string>;
};

const initialState: State = {
  sessionId: undefined,
  attribution: undefined,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSession: (state, action: PayloadAction<State['sessionId']>) => ({
      ...state,
      sessionId: action.payload,
    }),
    setAttribution: (
      state,
      action: PayloadAction<Record<string, string>>,
    ) => ({
      ...state,
      // Last-touch per key: a new landing overwrites only the params it actually
      // carries; params absent from the new hit keep their previous value.
      attribution: { ...state.attribution, ...action.payload },
    }),
    resetSession: () => initialState,
  },
  selectors: {
    sessionId: state => state.sessionId,
    attribution: state => state.attribution,
  },
});

export const sessionActions = sessionSlice.actions;

declare module '~shared/store' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
  export interface LazyLoadedSlices extends WithSlice<typeof sessionSlice> {}
}

const injectedSessionSlice = sessionSlice.injectInto(rootReducer);

export const sessionSelectors = injectedSessionSlice.selectors;
